import { Component, Input } from '@angular/core';
import { FuSlotStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';

@Component({
    selector: 'app-fu-slot-status-indicator',
    templateUrl: './fu-slot-status-indicator.component.html',
    styleUrls: ['./fu-slot-status-indicator.component.scss'],
    standalone: false,
})
export class FuSlotStatusIndicatorComponent {
    @Input() isReceivingData: boolean;
    @Input() index: number;
    @Input() fuSlot: FuSlotStatus;

    constructor(private systemStatusService: SystemStatusService) {}

    hasAlarms(): boolean {
        if (!this.isReceivingData) return false;
        return this.systemStatusService.getAlarmCounts(this.fuSlot) > 0;
    }

    getIcon(alarmValue: 0 | 1): string {
        if (!this.isReceivingData) return '';
        if (alarmValue === 0) {
            return 'status-error';
        } else if (alarmValue === 1) {
            return 'status-check';
        }
    }
}
